import React from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router";

function PaymentFailure() {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const error = searchParams.get('error');

  const getErrorMessage = () => {
    if (error === "cancelled") return "You cancelled the payment process.";
    if (error === "card_declined") return "Your card was declined. Please try a different payment method.";
    if (error === "insufficient_funds") return "Your card has insufficient funds.";
    return "Something went wrong with your payment. Please try again.";
  };
// console.log("todo")
  return (
    <div className="min-h-screen bg-white px-4 sm:px-6 lg:px-8">
      <Header />
      <div className="max-w-7xl mx-auto py-8">
        <div className="max-w-3xl mx-auto text-center">
          <FaExclamationTriangle className="h-16 w-16 text-yellow-500 mx-auto mb-6" />

          <h1 className="text-3xl font-bold text-black mb-4">
            Payment Failed
          </h1>

          <p className="text-gray-600 mb-8">
            {getErrorMessage()}
          </p>

          <div className="bg-gray-50 p-6 rounded-lg mb-8">
            <h2 className="text-lg font-semibold text-black mb-4">
              Need help?
            </h2>
            <ul className="text-left text-gray-600 space-y-2">
              <li className="flex items-start">
                <span className="text-black mr-2">•</span>
                Check that your payment details are correct
              </li>
              <li className="flex items-start">
                <span className="text-black mr-2">•</span>
                Try a different payment method
              </li>
              <li className="flex items-start">
                <span className="text-black mr-2">•</span>
                Contact support if the problem persists
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate("/pricing")}
              className="px-6 py-3 bg-black text-white rounded-md font-medium hover:bg-gray-800 transition-colors"
            >
              Try Again
            </button>
            <button
              onClick={() => navigate("/contact-us")}
              className="px-6 py-3 border border-black text-black rounded-md font-medium hover:bg-gray-100 transition-colors"
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>
      <div className="py-12">
        <Footer />
      </div>
    </div>
  );
}

export default PaymentFailure;